module.exports = __webpack_public_path__ + "media/images/icons/credit_card_visa-b9851ca639c11c1b0d22ef36722199fc.svg";